"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.proofspaceAllowedCensus = exports.PROOFSPACE_STRATEGY = void 0;
const consts_1 = require("../vocdoni/consts");
exports.PROOFSPACE_STRATEGY = 'proofspace';
exports.proofspaceAllowedCensus = [consts_1.VOCDONI_CENSUS_OFFCHAIN, consts_1.VOCDONI_CENSUS_CSP_NBNS, consts_1.VOCDONI_CENSUS_CSP_BLINDNS];
